import React from 'react';

const AboutFacility = () => {
  return (
    <section id="about" className="about-facility-section py-5 bg-white border-bottom">
      <div className="container py-lg-4">
        {/* Section Header */}
        <div className="text-center max-w-700 mx-auto mb-5">
          <div className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill bg-light border text-primary small fw-semibold mb-2">
            <i className="fas fa-certificate"></i>
            <span>Established in 1997</span>
          </div>
          <h2 className="fw-bold text-dark mb-2 display-6">
            About <b>A.B. Engineering Works</b>
          </h2>
          <div className="text-primary fw-semibold fs-5 mb-2">
            Precision Engineering &amp; Machinery Spares Specialists
          </div>
          <p className="text-muted fs-6 mb-0" style={{ lineHeight: '1.6' }}>
            Nearly three decades of specialized craftsmanship in manufacturing and repairing critical machinery for pharmaceutical ampoule and vial packaging lines across India.
          </p>
        </div>

        {/* Content Row */}
        <div className="row g-4 g-lg-5 align-items-center">
          {/* Left Column: Narrative & Pillars */}
          <div className="col-lg-6">
            <h4 className="fw-bold text-dark mb-3">
              Reliable Partner for Critical Production Lines
            </h4>
            <p className="text-secondary mb-4" style={{ lineHeight: '1.7' }}>
              We understand that downtime on pharmaceutical filling and sealing lines costs thousands per hour. That is why our manufacturing workshop in Santacruz East is engineered for precision, high durability, and rapid emergency turnaround.
            </p>

            {/* 3 Core Capability Points */}
            <div className="d-flex flex-column gap-3 mb-4">
              <div className="d-flex align-items-start gap-3 p-3 bg-light rounded-3 border">
                <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 mt-1" style={{ width: '38px', height: '38px' }}>
                  <i className="fas fa-check"></i>
                </div>
                <div>
                  <h6 className="fw-bold text-dark mb-1">OEM-Grade Precision Components</h6>
                  <p className="text-muted small mb-0">
                    Machined to micro-tolerances (±0.005mm) using high-grade stainless steel 316L, hardened tool steel, and heat-treated alloys.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start gap-3 p-3 bg-light rounded-3 border">
                <div className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 mt-1" style={{ width: '38px', height: '38px' }}>
                  <i className="fas fa-wrench"></i>
                </div>
                <div>
                  <h6 className="fw-bold text-dark mb-1">Expert Machine Repairing &amp; Overhauling</h6>
                  <p className="text-muted small mb-0">
                    Complete refurbishment of ampoule and vial forming machines, chuck assemblies, and SM-3 machine drives.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start gap-3 p-3 bg-light rounded-3 border">
                <div className="bg-info text-white rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 mt-1" style={{ width: '38px', height: '38px' }}>
                  <i className="fas fa-drafting-compass"></i>
                </div>
                <div>
                  <h6 className="fw-bold text-dark mb-1">Custom Re-engineering &amp; Tooling</h6>
                  <p className="text-muted small mb-0">
                    Reverse engineering for obsolete or imported machinery parts directly from technical drawings or physical samples.
                  </p>
                </div>
              </div>
            </div>

            <div className="d-flex flex-column flex-sm-row gap-2 align-items-stretch align-items-sm-center">
              <a href="#contact" className="btn btn-primary px-3.5 py-2 fw-semibold rounded-2 d-inline-flex align-items-center justify-content-center gap-2">
                <i className="fas fa-phone-alt small"></i>
                <span>Contact Our Workshop</span>
              </a>
              <a href="#products" className="btn btn-outline-secondary px-3.5 py-2 fw-medium rounded-2 d-inline-flex align-items-center justify-content-center">
                <span>Explore Spare Parts</span>
              </a>
            </div>
          </div>

          {/* Right Column: Workshop Capabilities & Standards */}
          <div className="col-lg-6">
            <div className="facility-spec-card bg-white border rounded-3 p-4 shadow-sm">
              <div className="d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom flex-wrap gap-2">
                <div className="d-flex align-items-center gap-3">
                  <img
                    src="/logo192.png"
                    alt="A.B. Engineering Works"
                    className="site-logo"
                    width="44"
                    height="44"
                  />
                  <div>
                    <h6 className="fw-bold text-dark mb-0">Workshop &amp; Technical Capabilities</h6>
                    <span className="text-muted text-xs">Santacruz East, Mumbai Facility</span>
                  </div>
                </div>
                {/* <div className="d-flex align-items-center gap-2 bg-light border border-warning border-opacity-25 px-2.5 py-1.5 rounded-2 shadow-2xs">
                  <img
                    src="/msme-gold-logo.png"
                    alt="MSME Registered Unit"
                    width="28"
                    height="32"
                    className="object-fit-contain"
                  />
                  <div className="lh-1 text-start">
                    <span className="fw-bold text-dark d-block" style={{ fontSize: '0.78rem' }}>MSME Registered</span>
                    <span className="text-muted" style={{ fontSize: '0.65rem' }}>Govt. of India Unit</span>
                  </div>
                </div> */}
              </div>

              {/* Spec Grid */}
              <div className="row g-3">
                <div className="col-sm-6">
                  <div className="p-3 bg-light rounded-2 border h-100">
                    <div className="text-xs fw-bold text-uppercase text-muted mb-1">
                      <i className="fas fa-cogs text-primary me-1"></i> In-House Machining
                    </div>
                    <ul className="list-unstyled text-dark small mb-0 lh-base">
                      <li>• Heavy Lathe Turning</li>
                      <li>• Precision Milling</li>
                      <li>• Cylindrical Grinding</li>
                      <li>• Surface Finishing</li>
                    </ul>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="p-3 bg-light rounded-2 border h-100">
                    <div className="text-xs fw-bold text-uppercase text-muted mb-1">
                      <i className="fas fa-layer-group text-primary me-1"></i> Materials Handled
                    </div>
                    <ul className="list-unstyled text-dark small mb-0 lh-base">
                      <li>• SS 304 &amp; SS 316L</li>
                      <li>• HCHCr / D2 Tool Steel</li>
                      <li>• EN8, EN19, EN24 Alloys</li>
                      <li>• Phosphor Bronze &amp; Brass</li>
                    </ul>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="p-3 bg-light rounded-2 border h-100">
                    <div className="text-xs fw-bold text-uppercase text-muted mb-1">
                      <i className="fas fa-microscope text-primary me-1"></i> Quality &amp; Inspection
                    </div>
                    <ul className="list-unstyled text-dark small mb-0 lh-base">
                      <li>• Digital Micrometer Checks</li>
                      <li>• Hardness Verification (HRC)</li>
                      <li>• Concentricity &amp; Runout Testing</li>
                      <li>• Zero-Defect Standard</li>
                    </ul>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="p-3 bg-light rounded-2 border h-100">
                    <div className="text-xs fw-bold text-uppercase text-muted mb-1">
                      <i className="fas fa-shield-alt text-primary me-1"></i> Client Advantage
                    </div>
                    <ul className="list-unstyled text-dark small mb-0 lh-base">
                      <li>• 28+ Years Proven Experience</li>
                      <li>• Govt. Registered MSME Enterprise</li>
                      <li>• Rapid Emergency Dispatch</li>
                      <li>• Direct Owner Attention</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutFacility;
